import { useT } from "@transifex/react";
import useBreakpoints, { Breakpoint } from "../../../hooks/useBreakpoints";
import { ButtonColorVariant, ButtonVariant, AreaButton } from "../AreaButton";
import { ListItemWithCheck } from "../ListItemWithCheck";
import { CardVariant, type CardCommonProps } from "./Card.type";
import { CardHeader } from "./CardHeader";

export const HorizontalCard = (props: CardCommonProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const t = useT();
    const t_card = t("Card:", { _tags: "TeacherArea" });

    return (
        <div
            className={`rounded-medium border-stone-400 overflow-hidden border bg-white flex ${getStyleBasedOnBreakpoint(
                Breakpoint.MD,
                "flex-row",
                "flex-col"
            )}`}
            aria-label={props.ariaLabel ?? `${t_card} ${props.title}`}
        >
            <div className={`relative ${getStyleBasedOnBreakpoint(Breakpoint.MD, "h-auto w-2/5", "h-[150px] w-full")}`}>
                <img
                    src={props.image.src}
                    alt={props.image.alt}
                    className={`h-full w-full object-cover ${getStyleBasedOnBreakpoint(
                        Breakpoint.MD,
                        "absolute inset-0"
                    )}`}
                />
            </div>

            <div className={`p-m gap-s flex flex-col ${getStyleBasedOnBreakpoint(Breakpoint.MD, "w-3/5", "w-full")}`}>
                <div className="gap-s flex flex-col">
                    <CardHeader
                        title={props.title}
                        subtitle={props.subtitle}
                        variant={CardVariant.HORIZONTAL}
                        level={props.headlineLevel ?? 3}
                    />

                    {props.description && (
                        <p
                            className={`text-m text-stone-1000 ${getStyleBasedOnBreakpoint(
                                Breakpoint.MD,
                                "text-left",
                                "text-center"
                            )}`}
                        >
                            {props.description}
                        </p>
                    )}
                </div>

                {props.checkmarks && (
                    <ul className="gap-xs flex flex-col">
                        {props.checkmarks.map((text) => (
                            <ListItemWithCheck
                                key={`horizontalCard-list-item${text.replace(/\s/g, "")}`}
                                text={text}
                            />
                        ))}
                    </ul>
                )}

                <div
                    className={`gap-xs flex flex-wrap ${getStyleBasedOnBreakpoint(
                        Breakpoint.MD,
                        "flex-row",
                        "flex-col"
                    )}`}
                >
                    <div className={`flex-1 ${getStyleBasedOnBreakpoint(Breakpoint.MD, "whitespace-nowrap")}`}>
                        {props.secondaryButton && (
                            <AreaButton
                                variant={ButtonVariant.SECONDARY}
                                colorVariant={ButtonColorVariant.LUMINA}
                                {...props.secondaryButton}
                            >
                                {props.secondaryButton.text}
                            </AreaButton>
                        )}
                    </div>
                    {
                        <div className={`flex-1 ${getStyleBasedOnBreakpoint(Breakpoint.MD, "whitespace-nowrap")}`}>
                            {props.primaryButton && (
                                <AreaButton
                                    variant={ButtonVariant.PRIMARY}
                                    colorVariant={ButtonColorVariant.LUMINA}
                                    {...props.primaryButton}
                                >
                                    {props.primaryButton.text}
                                </AreaButton>
                            )}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};
